import React from 'react'
import Form from '../../../form'
import Quote from '../../../quote'

const EnergyFit: React.FC = () => {
  return (
    <>
      <div className='onlinepbx__container'>

        <div className='onlinepbx__story'>
          <div className='onlinepbx__story__block__row onlinepbx__story__block__row__head onlinepbx__story__block__row__bottom'>
            <div className='onlinepbx__story__left onlinepbx__story__description'>
              <h2>
                Как правильно работать с&nbsp;пропущенными: кейс фитнес-клуба, который увеличил выручку на&nbsp;30%
              </h2>
                <div className='onlinepbx__story__text onlinepbx__story__text__head'>
                  <div className='onlinepbx__story__text__paragraph'>
                    Energy-Fit поделился своим опытом, как получить больше заявок от&nbsp;клиентов без увеличения затрат на&nbsp;рекламу
                </div>
              </div>
              <div>
                <Form text='Попробовать onlinepbx' pageName='Истории' />
              </div>
            </div>
            <div className='onlinepbx__story__right onlinepbx__story__image'>
              <img src={process.env.PUBLIC_DIR + '/images/stories/story3-big.jpg'} />
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story2__block1'>
            <div>
              <h2 className='onlinepbx__content__header__center'>
                Определили проблему: клиенты теряются по&nbsp;пути к&nbsp;отделу продаж и&nbsp;администратору
              </h2>
              <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
                <Quote width='922'>
                  <>
                    <div>У&nbsp;каждого фитнес-клуба не&nbsp;было единого номера, голосовых приветствий и&nbsp;автоответчиков в&nbsp;нерабочее время. Заявки терялись при переводе звонков между клубами, администраторы не&nbsp;перезванивали по&nbsp;пропущенным, а&nbsp;клиенты не&nbsp;знали, свяжутся&nbsp;ли с&nbsp;ними когда-нибудь.</div>
                  </>
                </Quote>
              </div>
            </div>

            <div className='onlinepbx__story__block onlinepbx__story__block2'>
              <h2 className='onlinepbx__content__header__center'>
                Как решили: внедрили amoCRM<br/> и&nbsp;подключили телефонию
              </h2>
                <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center onlinepbx__story--no-padding-top'>
                  <div className='onlinepbx__story__left onlinepbx__story__image'>
                    <img src={process.env.PUBLIC_DIR + '/images/stories/story3-block1.jpg'} alt=""/>
                  </div>
                  <div className='onlinepbx__story__right onlinepbx__story__description' >
                    <div className='onlinepbx__story__block__header'>1. Подключили единый номер для всех фитнес-клубов сети</div>
                    <div className='onlinepbx__story__text'>
                      <div className='onlinepbx__story__text__paragraph'>
                        В&nbsp;рекламных объявлениях, на&nbsp;сайте и&nbsp;в&nbsp;соцсетях указываем один номер, и&nbsp;принимаем звонки на&nbsp;несколько устройств.
                      </div>
                    </div>
                    <div className='onlinepbx__story__block__thumb'>
                      <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                      <div className='onlinepbx__story__text__medium'>
                        Имеем репутацию надежной компании, которая всегда на&nbsp;связи с&nbsp;клиентом.
                      </div>
                    </div>
                  </div>
                </div>

                <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
                  <div className='onlinepbx__story__left onlinepbx__story__description' >
                    <div className='onlinepbx__story__block__header'>2. Настроили голосовые приветствия</div>
                    <div className='onlinepbx__story__text'>
                      <div className='onlinepbx__story__text__paragraph'>
                        Вместо гудков клиенты слышат welcome-фразу приятным женским голосом: &laquo;Здравствуйте, вы&nbsp;позвонили в&nbsp;фитнес-клуб Energy-Fit!&raquo;. Далее через интерактивное меню клиент выбирает цель звонка и&nbsp;перенаправляется на&nbsp;сотрудника.
                      </div>
                    </div>
                    <div className='onlinepbx__story__block__thumb'>
                      <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                      <div className='onlinepbx__story__text__medium'>
                        Телефон стал удобной и&nbsp;информативной точкой входа клиента в&nbsp;компанию.
                      </div>
                    </div>
                  </div>
                  <div className='onlinepbx__story__right onlinepbx__story__image'>
                    <img src={process.env.PUBLIC_DIR + '/images/stories/story3-block2.jpg'} alt=""/>
                  </div>
                </div>

                <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
                  <div className='onlinepbx__story__left onlinepbx__story__image'>
                    <img src={process.env.PUBLIC_DIR + '/images/stories/story3-block3.jpg'} alt=""/>
                  </div>
                  <div className='onlinepbx__story__right onlinepbx__story__description' >
                    <div className='onlinepbx__story__block__header'>3. Подключили автоответчик</div>
                    <div className='onlinepbx__story__text'>
                      <div className='onlinepbx__story__text__paragraph'>
                        Клиент слышит сообщение с&nbsp;графиком работы фитнес-клуба когда звонит в&nbsp;нерабочее время или привлекательную акцию, которая мотивирует на&nbsp;покупку абонемента.
                      </div>
                    </div>
                    <div className='onlinepbx__story__block__thumb'>
                      <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                      <div className='onlinepbx__story__text__medium'>
                        Просто и&nbsp;с&nbsp;минимальными затратами информируем клиентов в&nbsp;нерабочее время.
                      </div>
                    </div>
                  </div>
                </div>

                <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
                  <div className='onlinepbx__story__left onlinepbx__story__description' >
                    <div className='onlinepbx__story__block__header'>4. Настроили правила переадресации</div>
                    <div className='onlinepbx__story__text'>
                      <div className='onlinepbx__story__text__paragraph'>
                        Входящие звонки обрабатываются amoCRM и&nbsp;автоматически переводятся на&nbsp;ответственного&nbsp;&mdash; клиент сразу попадает к&nbsp;нужному ему менеджеру.
                      </div>
                    </div>
                    <div className='onlinepbx__story__block__thumb'>
                      <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                      <div className='onlinepbx__story__text__medium'>
                        Каждый клиент автоматически переводится на&nbsp;персонального менеджера.
                      </div>
                    </div>
                  </div>
                  <div className='onlinepbx__story__right onlinepbx__story__image'>
                    <img src={process.env.PUBLIC_DIR + '/images/stories/story3-block4.jpg'} alt=""/>
                  </div>
                </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block2 onlinepbx__story--mb'>
            <h2 className='onlinepbx__content__header__center'>
              В результате
            </h2>
            <div className='onlinepbx__story__text onlinepbx__story__text--custom-margin'>После того, как настроили воронки продаж и&nbsp;статистику, стало понятно, что пропущенных звонков было&nbsp;50% и&nbsp;никто по&nbsp;ним не&nbsp;перезванивал. После настройки телефонии пропущенных вызовов в&nbsp;рабочее время не&nbsp;стало. А&nbsp;в&nbsp;нерабочее&nbsp;&mdash; администраторы перезванивают по&nbsp;пропущенным как можно скорее.</div>
            <div className='onlinepbx__story__block__center onlinepbx__story__block__info-card'>
              <div>В&nbsp;итоге количество клиентов <span>увеличилось на&nbsp;10%</span>, прибыль выросла и&nbsp;появились деньги<br/> для запуска нового фитнес-клуба.</div>
            </div>
          </div>

        </div>

      </div>

      <div className='onlinepbx__story__block__form__wrapper'>
        <h2 className='onlinepbx__content__header__center'>
          Настроим сервис <span className='onlinepbx__content__header__green'>бесплатно</span> за 30 минут!
        </h2>
        <div className='onlinepbx__story__block__form'>
          <Form free isWhite text='Подключить бесплатно' pageName='Истории' />
        </div>
      </div>
    </>
  )
}

export default EnergyFit
